import type {Result, UseCase} from 'framework';
import type {SettingsError} from '../../domain/errors';
import type {UserReminder} from '../../domain/user-reminder';
import type {SettingsRepository} from '../ports/settings.repository';

export class ListDueReminders implements UseCase<[], readonly UserReminder[]> {
  constructor(private readonly repository: SettingsRepository) {}

  execute(): Promise<Result<readonly UserReminder[], SettingsError>> {
    return this.repository.listDueReminders();
  }
}
